import * as React from 'react';
import * as types from 'modules/types/smSupplierManagement';
import { findDOMNode } from 'react-dom';
import { element } from 'utils';
import ResizeObserver from 'resize-observer-polyfill';
import _ from 'lodash';
import { Form, Card } from '@beehive/components';
import { BANK_INFO_KEYS } from '../utils';
import { renderForm, HandleChagneParams } from './BasicInfo';
import PropTypes from 'prop-types';
import pageMessages from 'messages/Models/BankInfo';
import titleMessages from 'messages/CompanyManagement/CardTitle';

const messages = { ...pageMessages, ...titleMessages };

const FORM_KEYS = Object.keys(BANK_INFO_KEYS).map((key: string) => `bank_info.${key}`);

export interface BankInfoProps {
  data: types.SupplierMangementDetail;
  onChange: any;
  bankInfoKeys: string[];
}

class BankInfo extends React.Component<BankInfoProps, any> {
  public static defaultProps = {
    bankInfoKeys: Object.keys(BANK_INFO_KEYS),
  };
  public static contextTypes = {
    intl: PropTypes.object,
  };

  private resizeObserver: ResizeObserver | undefined;
  private thisDOM: Element | undefined;

  constructor(props: BankInfoProps) {
    super(props);
  }

  public componentDidMount() {
    this.resizeObserver = new ResizeObserver(this.handleResize);
    const thisDOM = findDOMNode(this);
    if (thisDOM instanceof Element) {
      this.thisDOM = thisDOM;
      // @ts-ignore
      const parentRow = element.closest(thisDOM, '.beehive-row-flex');
      if (parentRow) {
        this.resizeObserver.observe(parentRow);
      }
    }
  }

  public shouldComponentUpdate(nextProps: BankInfoProps) {
    const pickKeys = ['data.bank_info', 'data.detailError.messages', 'data.loading', 'data.loaded'];
    const thisData = _.pick(this.props, pickKeys);
    const nextData = _.pick(nextProps, pickKeys);
    if (_.isEqual(thisData, nextData)) {
      return false;
    }
    return true;
  }

  public componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  // 修改内容
  private handleChange = (params: HandleChagneParams) => {
    const { onChange, data } = this.props;
    const { bank_info = {} } = data;
    const { key, value } = params;
    // 注意`bank_info.bank_number`是一个整体，直接get会拿不到值
    const error = _.get(_.get(data, `detailError.messages`), `bank_info.${key}`);
    const newDetailError = _.cloneDeep(data.detailError);
    if (error) {
      delete newDetailError.messages[`bank_info.${key}`];
    }
    const newData = {
      ...data,
      detailError: { ...newDetailError },
      bank_info: { ...bank_info, [key]: value },
    };
    onChange(newData);
  }

  private handleResize = (entries: ResizeObserverEntry[], observer: ResizeObserver) => {
    if (this.thisDOM) {
      const parent = this.thisDOM.parentNode;
      let siblingHeight = 0;
      if (parent) {
        const sibling = parent.firstElementChild;
        siblingHeight = sibling && sibling.getBoundingClientRect().height || 0;
      }
      for (const entry of entries) {
        const { height } = entry.contentRect;
        const thisDOMHeight = height - siblingHeight - 16;
        // @ts-ignore
        this.thisDOM.style.height = thisDOMHeight + 'px';
      }
    }
  }

  public render() {
    const { intl } = this.context;
    const { bankInfoKeys = [], data: { bank_info = {}, options, loading, saveClicked } } = this.props;
    const errorMsg = _.pick(_.get(this.props.data, 'detailError.messages'), FORM_KEYS);
    return (
      <Card
        titleNode={intl.formatMessage(messages.bankInfo)}
        className="bank-info"
        loading={loading}
      >
        <Form isLabelVertical errorMsg={errorMsg} showError={saveClicked} mode="edit">
          {
            bankInfoKeys.map((key: string) => {
              const item = BANK_INFO_KEYS[key];
              const value = bank_info[key];
              return (
                <Form.Item
                  itemKey={`bank_info.${key}`}
                  label={item.label && intl.formatMessage(messages[item.label])}
                  required={!!item.required}
                  key={key}
                  itemColProps={{ span: 24 }}
                >
                  {renderForm({ key, value, options, data: BANK_INFO_KEYS, handleChange: this.handleChange })}
                </Form.Item>
              );
            })
          }
        </Form>
      </Card>
    );
  }
}

export default BankInfo;
